import {
  requestRemoveOs,
  requestForceVehicleExit,
  requestChangeAccount,
  requestImportClients
} from './services';

import { setIsLoading } from './actions';

import { toast } from 'react-toastify';

export const removeOs = (userId, establishmentId, params) => dispatch => {
  dispatch(setIsLoading(true));

  return requestRemoveOs(userId, establishmentId, params)
    .then(() => {
      toast.success('Operação realizada com sucesso.');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const forceVehicleExit = (userId, establishmentId, params) => dispatch => {
  dispatch(setIsLoading(true));

  return requestForceVehicleExit(userId, establishmentId, params)
    .then(() => {
      toast.success('Operação realizada com sucesso.');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const changeAccount = (userId, establishmentId, params) => dispatch => {
  dispatch(setIsLoading(true));

  return requestChangeAccount(userId, establishmentId, params)
    .then(() => {
      toast.success('Operação realizada com sucesso.');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const importClients = (userId, establishmentId, file) => dispatch => {
  dispatch(setIsLoading(true));

  return requestImportClients(userId, establishmentId, file)
    .then(() => {
      toast.success('Operação realizada com sucesso.');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}